import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataGridForm from "../../../components/common/DataGridForm";
import { FetchPersonalizado, catchError } from "../../../utils/fetch";
import { connect } from "react-redux";
import { loadingAction } from "../../../redux/actions";
import { AlertError, AlertConfirm2 } from "../../../components/alert"; 
import { copyToClickBoard } from '../../../utils/slug';

const ListaNewsletter = ({ isLoading, isLoadingAction }) => {
  const [publicaciones, setPublicaciones] = useState([]);

  useEffect(() => {
    
  
    fetchPublicaciones();
  }, [isLoadingAction]);

  const fetchPublicaciones = async () => {
    try {
      isLoadingAction(true); 
      const response = await FetchPersonalizado("FileUpload/publicaciones", "GET", null);
      console.log("data", response.data);
      setPublicaciones(response.data);
      isLoadingAction(false); 
    } catch (error) {
      isLoadingAction(false);
      AlertError("Error al cargar los Newsletter.");
    }
  };

  const handlerOnOff = async (prmId, value) => {
    isLoadingAction(true);
    try {
      const endpoint = value ? `FileUpload/habilitar/${prmId}` : `FileUpload/deshabilitar/${prmId}`;
      await FetchPersonalizado(endpoint, "POST");
      fetchPublicaciones();
      isLoadingAction(false);
    } catch (error) {
      isLoadingAction(false);
      catchError(error);
    }
  };

  function Accion(data) {
    return (
      <>
        <button
          type="button"
          className="btn btn-sm btn btn-danger"
          onClick={() => {
            RenderAlert("Está apunto de eliminar este contenido", data.id);
          }}
        >
          <i className="fa fa-trash" />
        </button>{" "}
      </>
    );
  }
  function RenderAlert(title, id) {
    AlertConfirm2(title, "question", (response) => {
      if (response.isConfirmed) {
        deleteContenido(id);
      }
    });
  }

  const deleteContenido = async (id) => {
    isLoadingAction(true);
    try {
      await FetchPersonalizado("FileUpload/eliminar/" + id, "delete");
      fetchPublicaciones();
      isLoadingAction(false);
    } catch (error) {
      console.error("mostrando error", error);
      isLoadingAction(false);
      catchError(error);
    }
  };

  function OnOff(data) {
    return (
      <div className="custom-control custom-switch">
        <input
          type="checkbox"
          checked={data.isEnabled}
          className="custom-control-input"
          onChange={(v) => handlerOnOff(data.id, v.target.checked)}
          id={"csPublicado" + data.id}
        />
        <label
          role="button"
          className="custom-control-label"
          for={"csPublicado" + data.id}
        ></label>
      </div>
    );
  }

  function Slug(data) {
    return (
        <>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id={`tooltip-top`}>
                        Hacer click para copiar url
                    </Tooltip>
                }
            >
                <i className='fa fa-copy fa-lg text-info' role="button"
                    onClick={() => copyToClickBoard(data.url)}
                ></i>
            </OverlayTrigger>
        </>
    )
}

function FechaPublicacion(data) {
  const fecha = new Date(data.fechaPublicacion); 
  const opciones = { year: 'numeric', month: 'numeric' }; 
    
  const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones); 
  return (
      <>
          <span>{fechaFormateada}</span>
      </>
  );
}

  return (
    <React.Fragment>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              <div className="float-right mt-10">
                <Link
                  to="/newsletter/nuevo"
                  className="btn btn-primary btn-rounded box-shadow btn-icon"
                >
                  <i className="fa fa-plus" /> Nueva Publicación
                </Link>
              </div>
              Listado de Newsletters en revisión
            </Card.Header>
            <Card.Body>
              <DataGridForm
                dataSource={publicaciones}
                keyExpr="id"
                allowReordering={false}
                columnHidingEnabled={true}
                columns={[
                  { caption: "id", dataField: "id", visible: false },
                  { caption: "Nombre", dataField: "nombre" },
                  
                  { caption: 'Url', alignment: 'center', width: 50, render: 'Slug', cellRender: { Slug } },
                  //{ caption: "Url", dataField: "url" },
                  { caption: "Nombre Archivo", dataField: "nombreArchivo" },
                  {
                    caption: "Fecha Publicacion",
                    render: "FechaPublicacion",
                    cellRender: { FechaPublicacion }
                  },
                  {
                    caption: "Inactivo/Activo",
                    alignment: "center",
                    render: "OnOff",
                    cellRender: { OnOff },
                  },
                    
                  
                  { caption: "Fecha Creación", dataField: "fechaCreacion" },
                  { caption: "Nombre Zip", dataField: "nombreZip" },
                  {
                    caption: "Acción",
                    alignment: "center",
                    render: "Accion",
                    cellRender: { Accion },
                    hidingPriority: 0,
                  },
                ]}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loading,
});

const mapDispatchToProps = (dispatch) => ({
  isLoadingAction: (data) => dispatch(loadingAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListaNewsletter);
